import type { AlertListProps } from '../../../types/alerts.d';

import React from 'react';
import { TooltipProvider } from '@hdir/ui/tooltip';
import { Tab, TabGroup } from '@hdir/ui/tab';
import './alert-list.scss';
import { ActiveAlerts } from './ActiveAlerts';
import { ExpiredAlerts } from './ExpiredAlerts';


export function AlertList(props: AlertListProps): React.JSX.Element {
	// ─────────────────────────────────────────────────────────────────────────────────────────────
	// Props
	// ─────────────────────────────────────────────────────────────────────────────────────────────
	const {
		alertContentId,
		activeAlerts,
		activeAlertsCount,
		countyBuckets,
		drugTypeBuckets,
		expiredAlerts,
		expiredAlertsCount,
		graphqlServiceUrl,
		locale,
		isExpired,
		initialCountyFromParams,
		initialDrugTypeFromParams,
	} = props;

	console.log(props);

	// Sorting alerts with type varsling to the top of the list
	const sortedActiveAlerts = [
		...activeAlerts.filter(a => a.alertType === 'varsling'),
		...activeAlerts.filter(a => a.alertType !== 'varsling'),
	];


	// ─────────────────────────────────────────────────────────────────────────────────────────────
	// View
	// ─────────────────────────────────────────────────────────────────────────────────────────────
	return (
		<TooltipProvider>
			<section className="alert-list flex flex-col pb-xl tablet:pb-xxl">
				<h1 className="!font-bold my-lg text-balance">Varsler om farlige rusmidler i omløp</h1>
				<TabGroup className="flex flex-col gap-sm" defaultValue={!isExpired ? "0" : "1"}>
					<Tab tabLabel={`Aktive varsler (${activeAlertsCount})`}>
						<ActiveAlerts
							alertContentId={alertContentId}
							activeAlerts={sortedActiveAlerts}
							activeAlertsCount={activeAlertsCount}
						/>
					</Tab>
					<Tab tabLabel="Tidligere varsler">
						<ExpiredAlerts
							countyBuckets={countyBuckets}
							drugTypeBuckets={drugTypeBuckets}
							expiredAlerts={expiredAlerts}
							expiredAlertsCount={expiredAlertsCount}
							graphqlServiceUrl={graphqlServiceUrl}
							locale={locale}
							initialCountyFromParams={initialCountyFromParams}
							initialDrugTypeFromParams={initialDrugTypeFromParams}
						/>
					</Tab>
				</TabGroup>
			</section>
		</TooltipProvider>
	);
}
